export default __webpack_public_path__ + "static/media/argen-ipsum.04da1e5b.png";